import { render } from "./FilterDate.vue?vue&type=template&id=25bb20a6"
import script from "./FilterDate.vue?vue&type=script&lang=js"
export * from "./FilterDate.vue?vue&type=script&lang=js"
script.render = render

export default script